import { render, staticRenderFns } from "./IssueCardFoldable.vue?vue&type=template&id=ab0ca0cc"
import script from "./IssueCardFoldable.vue?vue&type=script&lang=js"
export * from "./IssueCardFoldable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports